<template>
    <hts-drawer
        v-model="visible"
        :custom="['header', 'footer']"
        :title="$t('labels.addDocument')"
        :submit="visibleSubmit"
        :rules="rules.addDocumentVehicle"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="resetField()">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-select
                    v-model="dataFormAddDocument.type"
                    :label="$t('labels.documentType')"
                    required
                    :items="listTypeDocument"
                    key-id="key"
                    key-label="value"
                    :color="color"
                    name="documentType"
                    prop="documentType"
                    @change="(data: any) => handleChangeType(data)" />
                <hts-form-input
                    v-model="dataFormAddDocument.fileName"
                    :label="$t('labels.documentFileName')"
                    :color="color"
                    name="documentFileName"
                    prop="documentFileName" />
                <hts-form-input
                    v-if="dataFormAddDocument.type === listTypeDocument[0].key"
                    v-model="dataFormAddDocument.insurancePrice"
                    required
                    :label="$t('labels.insurancePriceByYear')"
                    :color="color"
                    type="number"
                    name="insurancePriceByYear"
                    prop="insurancePriceByYear" />
                <hts-form-date
                    v-if="dataFormAddDocument.type === listTypeDocument[0].key"
                    v-model="dataFormAddDocument.expiredDate"
                    :label="$t('labels.expiredDate')"
                    :color="color"
                    required
                    name="expiredDate"
                    prop="expiredDate" />
                <hts-form-file
                    ref="file"
                    v-model="fileDocument"
                    :required="true"
                    type="file"
                    :label="$t('labels.document')"
                    name="document"
                    prop="document" />
                <hts-form-date
                    v-if="dataFormAddDocument.type === listTypeDocument[1].key"
                    v-model="dataFormAddDocument.expiredDate"
                    required
                    :label="$t('labels.expiredDate')"
                    :color="color"
                    name="expiredDate"
                    prop="expiredDate" />
                <hts-form-input
                    v-model="dataFormAddDocument.description"
                    :label="$t('labels.description')"
                    :color="color"
                    name="description"
                    prop="description" />
            </div>
        </hts-card>

        <hts-modal
            :show="showConfirmAddDocument"
            :title="$t('labels.confirmCreateDocument')"
            type="confirm"
            :content="$t('labels.contentConfirmExpiredDateDocument')"
            @hide="showConfirmAddDocument = false"
            @confirm="handleSubmitFormAddDocument" />
    </hts-drawer>
</template>

<script lang="ts" setup>
import form, { IVehicleDocument } from '../imports/form'
const { rules } = form

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 2
  },
  type: {
    type: String,
    default: ''
  }
})

const emits = defineEmits(['refreshDataTables'])

const _initForm = {
  document: '',
  fileName: '',
  type: '',
  privacy: '',
  description: '',
  expiredDate: '',
  insurancePrice: null
}
const dataFormAddDocument = reactive<IVehicleDocument>({ ..._initForm })
const fileDocument = ref<File | string>('')

const visible = ref(false)
const idVehicle = ref('')

const openAddDocument = (id: any) => {
  if (!id) {
    return
  }

  idVehicle.value = id
  visible.value = true
}
defineExpose({
  openAddDocument
})

const resetField = () => {
  fileDocument.value = ''
  Object.assign(dataFormAddDocument, { ..._initForm })
}
const listTypeDocument = [
  {
    key: 'INSURANCE',
    value: $t('labels.vehicleModule.insurance')
  },
  {
    key: 'REGISTRY',
    value: $t('labels.registry')
  },
  {
    key: 'OTHER',
    value: $t('labels.other')
  }
]
const showConfirmAddDocument = ref(false)
const visibleSubmit = async () => {
  if (
    dataFormAddDocument.type &&
    ['REGISTRY', 'INSURANCE'].includes(dataFormAddDocument.type) &&
    dataFormAddDocument.expiredDate &&
    new Date(dataFormAddDocument.expiredDate + ' 23:59:59').getTime() < new Date().getTime()
  ) {
    showConfirmAddDocument.value = true
  } else {
    await handleSubmitFormAddDocument()
  }
}

const handleChangeType = (data: any) => {
  if (data.length > 0) {
    dataFormAddDocument.type = data[0].key
  }
}
const handleSubmitFormAddDocument = async () => {
  const dataForm = new FormData()
  dataForm.append('document', fileDocument.value)
  dataForm.append('fileName', dataFormAddDocument.fileName || '')
  dataForm.append(props.type, idVehicle.value)
  dataForm.append('type', dataFormAddDocument.type || '')
  dataForm.append('privacy', dataFormAddDocument.privacy || '')
  dataForm.append('description', dataFormAddDocument.description || '')
  dataForm.append('expiredDate', dataFormAddDocument.expiredDate || '')
  dataForm.append('insurancePrice', dataFormAddDocument.insurancePrice as unknown as string)
  const api =
    props.type === 'vehicle'
      ? {
        method: 'POST',
        url: '/vehicle/document/upload'
      }
      : {
        method: 'POST',
        url: '/vehicle/remooc-document/upload'
      }
  const data: any = await $api(api, { body: dataForm })

  const resData: any = data?.data.value
  if (resData.success) {
    process.client && $toast().success($t('notifications.addSuccessDocument'))
    visible.value = false
    resetField()
    emits('refreshDataTables')

    showConfirmAddDocument.value = false
  }
}

const closeOverSide = () => {
  visible.value = false
  resetField()
}
</script>
